<div class="h-100">
	<p class="mat-dialog-title">Zmień dane fakturowania</p>
	<div class="d-flex flex-row gap-2">
		<mat-form-field appearance="outline" class="fs-7">
			<mat-label>Numer NIP</mat-label>
			<input matInput [(ngModel)]="ownerNip" />
		</mat-form-field>
		<mat-form-field appearance="outline" class="fs-7">
			<mat-label>Numer Faktury</mat-label>
			<input matInput [(ngModel)]="invoiceNumber" />
		</mat-form-field>
	</div>
	<mat-dialog-actions align="end">
		<button mat-raised-button color="warn" (click)="closeDialog()">Anuluj</button>
		<button mat-raised-button color="primary" (click)="submit()">Zapisz</button>
	</mat-dialog-actions>
</div>
